import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import intance from "../utils/axios";

export const timKiemThongBaoChungTrangChu = async (idNhanVien: number, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.thongBaoChung.layDsThongBaoChungTrangChu, {
        "start": start,
        "length": length,
        "filter": {
            "idNhanVien": idNhanVien,
        },
        "orderBy": {
            "columnName": "id",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const capNhatTrangThaiDocThongBao = async (id: number, loaiCapNhat: number) => {
    var rs: number = 0;
    await intance.post(ApiPaths.thongBaoChung.CapNhatTrangThaiDoc + "?id=" + id + "&loaiCapNhat=" + loaiCapNhat)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = 1;
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}
